import { motion } from 'framer-motion';
import { FaDotCircle } from 'react-icons/fa';

const AcademiaLiveBadge = () => {
  // rendering custom live badge component here
  return (
    <div className='flex items-center justify-end'>
      <div className='relative mb-2'>
        <div className='relative bg-base-cyan text-sm text-base-white italic capitalize font-semibold px-5 py-1 rounded-md shadow-academia-sm z-10'>
          <div className='flex items-center justify-center gap-1'>
            <FaDotCircle />
            <p>Live</p>
          </div>
        </div>

        <motion.div
          initial={{ scaleX: 0, scaleY: 0, opacity: 1 }}
          animate={{
            scaleX: 1.4,
            scaleY: 1.8,
            opacity: 0,
            transition: {
              repeat: Infinity,
              repeatDelay: 1,
              duration: 0.7,
            },
          }}
          className='absolute top-0 left-0 h-full w-full rounded-md bg-base-red'
        ></motion.div>
      </div>
    </div>
  );
};

export default AcademiaLiveBadge;
